import { jsx as t } from "react/jsx-runtime";
import { NeuButton as n, NeuIcon as r } from "@hcahealthcaredpx/neutron-react";
const u = ({
  color: e = "blue",
  iconName: o,
  onClick: a,
  ariaLabel: i = "Icon button",
  isFilled: l = !1
}) => /* @__PURE__ */ t(
  n,
  {
    kind: "tertiary",
    size: "small",
    color: e,
    onClick: a,
    "aria-label": i,
    className: "px-1 px-sm-2",
    children: /* @__PURE__ */ t(r, { name: o, fill: l })
  }
);
export {
  u as M
};
